import { render, staticRenderFns } from "./blogGrid2.vue?vue&type=template&id=493dc184&"
import script from "./blogGrid2.vue?vue&type=script&lang=js&"
export * from "./blogGrid2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports